export class Locations {
    public uid: string;
    public name: string;
    public direction: string;
    public location_category_uid: string;
    public is_visible: boolean;
    public is_sucursal: boolean;
  }
  